import { atThisMoment } from "date-dealer";
import pkg from "../../package.json";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="bottom-footer">
        <div className="followme">
          <h3>Follow us</h3>
          <div className="social-media">
            <a
              href="https://www.facebook.com/profile.php?id=100078949548822"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook" />
            </a>
            <a
              href="https://instagram.com/alhandasyco?utm_medium=copy_link"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram" />
            </a>
          </div>
        </div>
        <div className="copyright">
          <p className="text">
            Copyright&copy;{atThisMoment("yyyy")} All rights reserved |{" "}
            {`V${pkg.version}`}
          </p>
        </div>{" "}
      </div>
    </footer>
  );
};

export default Footer;
